export const    COMMUNITY = 'COMMUNITY';
export const    COMMUNITY_SUCCESS = 'COMMUNITY_SUCCESS';
export const    COMMUNITY_ERROR = 'COMMUNITY_ERROR';

export const    COMMUNITY_ID = 'COMMUNITY_ID';
export const    COMMUNITY_ID_SUCCESS = 'COMMUNITY_ID_SUCCESS';
export const    COMMUNITY_ID_SUCCESS_CL = "COMMUNITY_ID_SUCCESS_CL";
export const    COMMUNITY_ID_ERROR = 'COMMUNITY_ID_ERROR';

export const    ADD_COMMUNITY = 'ADD_COMMUNITY';
export const    ADD_COMMUNITY_SUCCESS = 'ADD_COMMUNITY_SUCCESS';
export const    ADD_COMMUNITY_ERROR = 'ADD_COMMUNITY_ERROR';

export const    UPDATE_COMMUNITY = 'UPDATE_COMMUNITY';
export const    UPDATE_COMMUNITY_SUCCESS = 'UPDATE_COMMUNITY_SUCCESS';
export const    UPDATE_COMMUNITY_ERROR = 'UPDATE_COMMUNITY_ERROR';

export const DELETE_COMMUNITY = 'DELETE_COMMUNITY';
export const DELETE_COMMUNITY_SUCCESS= 'DELETE_COMMUNITY_SUCCESS';
export const DELETE_COMMUNITY_ERROR ='DELETE_COMMUNITY_ERROR';

export const PUTUSERBYCOMMUNITY_COMMUNITY = 'PUTUSERBYCOMMUNITY_COMMUNITY';
export const PUTUSERBYCOMMUNITY_COMMUNITY_SUCCESS= 'PUTUSERBYCOMMUNITY_COMMUNITY_SUCCESS';
export const PUTUSERBYCOMMUNITY_COMMUNITY_ERROR ='PUTUSERBYCOMMUNITY_COMMUNITY_ERROR';

export const    COMMUNITY_MEALS_TYPE = 'COMMUNITY_MEALS_TYPE';
export const    COMMUNITY_MEALS_TYPE_SUCCESS = 'COMMUNITY_MEALS_TYPE_SUCCESS';
export const    COMMUNITY_MEALS_TYPE_ERROR = 'COMMUNITY_MEALS_TYPE_ERROR';

export const    UPDATE_COMMUNITY_IMAGE = 'UPDATE_COMMUNITY_IMAGE';
export const    UPDATE_COMMUNITY_IMAGE_SUCCESS = 'UPDATE_COMMUNITY_IMAGE_SUCCESS';
export const    UPDATE_COMMUNITY_IMAGE_ERROR = 'UPDATE_COMMUNITY_IMAGE_ERROR';

export const GET_TAGS_COMMUNITY = 'GET_TAGS_COMMUNITY';
export const GET_TAGS_COMMUNITY_SUCCESS= 'GET_TAGS_COMMUNITY_SUCCESS';
export const GET_TAGS_COMMUNITY_ERROR ='GET_TAGS_COMMUNITY_ERROR';

export const COMMUNITY_BY_TAGS = 'COMMUNITY_BY_TAGS';
export const COMMUNITY_BY_TAGS_SUCCESS= 'COMMUNITY_BY_TAGS_SUCCESS';
export const COMMUNITY_BY_TAGS_ERROR ='COMMUNITY_BY_TAGS_ERROR';

export const CL_COMMUNITY = 'CL_COMMUNITY';
export const CL_COMMUNITY_SUCCESS= 'CL_COMMUNITY_SUCCESS';
export const CL_COMMUNITY_ERROR ='CL_COMMUNITY_ERROR';
